import React from 'react';
import { getUrl } from '~/helpers/url';

const Video = ({ src, title }) => {
  const url = src.startsWith('/static/') ? getUrl(src) : src;

  return (
    <video loop autoPlay muted title={title}>
      <source src={url} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default Video;
